import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function pullThread({ pullCount = 0, sessionId = null, excludeYarn = null } = {}) {
  const { data } = await client.post("/loom/pull", {
    pull_count: pullCount,
    session_id: sessionId,
    exclude_yarn: excludeYarn,
  });
  return data;
}

export async function signupEmail({ email, lastYarn = null }) {
  const { data } = await client.post("/loom/signup", {
    email,
    source: "loom",
    last_yarn: lastYarn,
  });
  return data;
}
